import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const SeweragePreventiveHouseKeepingTableDataAPI = createAsyncThunk("SeweragePreventiveHouseKeepingTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_SW_PumpingStationID,
        M_UserID,
        token,
        From,
        To,
        Flag,
        handleGetPDFUrl,
        handleSeweragePreventiveHouseKeepingExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_SW_T_SW_HouseKeeping_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate}&ToDate=${ToDate}&M_SW_PumpingStationID=${M_SW_PumpingStationID ? M_SW_PumpingStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSeweragePreventiveHouseKeepingExport && handleSeweragePreventiveHouseKeepingExport()
                handleGetPDFUrl(result.url)
                return result.data
            } else {
                return result
            }
        })
})

const SeweragePreventiveHouseKeepingTableDataSlice = createSlice({
    name: "SeweragePreventiveHouseKeepingTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SeweragePreventiveHouseKeepingTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(SeweragePreventiveHouseKeepingTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(SeweragePreventiveHouseKeepingTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SeweragePreventiveHouseKeepingTableDataReducer = SeweragePreventiveHouseKeepingTableDataSlice.reducer


// Excel Table Data
export const SeweragePreventiveHouseKeepingExcelDataAPI = createAsyncThunk("SeweragePreventiveHouseKeepingExcelData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_SW_PumpingStationID,
        M_UserID,
        token,
        From,
        To,
        Flag
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_SW_T_SW_HouseKeeping_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate}&ToDate=${ToDate}&M_SW_PumpingStationID=${M_SW_PumpingStationID ? M_SW_PumpingStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const SeweragePreventiveHouseKeepingExcelDataSlice = createSlice({
    name: "SeweragePreventiveHouseKeepingExcelData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SeweragePreventiveHouseKeepingExcelDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(SeweragePreventiveHouseKeepingExcelDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(SeweragePreventiveHouseKeepingExcelDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const SeweragePreventiveHouseKeepingExcelDataReducer = SeweragePreventiveHouseKeepingExcelDataSlice.reducer

// export const EnergyAuditTableExportDataAPI = createAsyncThunk("EnergyAuditTableExportData", async ({ data }) => {
//     const {
//         FromDate,
//         ToDate,
//         M_WardID,
//         M_SW_PumpingStationID,
//         M_UserID,
//         token,
//         From,
//         To,
//     } = data

//     var myHeaders = new Headers();
//     myHeaders.append("Authorization", "Bearer " + token);

//     var requestOptions = {
//         method: 'GET',
//         headers: myHeaders,
//         redirect: 'follow'
//     };
//     return fetch(`${BaseUrl}/APKDashboard/Get_WEB_SW_T_SW_EnergyAudit_Select?M_WardID=${M_WardID ? M_WardID : '0'}&FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_SW_PumpingStationID=${M_SW_PumpingStationID ? M_SW_PumpingStationID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
//         .then((res) => res.json())
//         .then((result) => {
//             if (result.code >= 200 && result.code <= 300 && result.data) {
//                 return result.data
//             } else {
//                 return result
//             }
//         })
// })

// const EnergyAuditTableExportDataSlice = createSlice({
//     name: "EnergyAuditTableExportData",
//     initialState: {
//         isExportLoading: false,
//         ExportTableData: null,
//         isError: false,
//     },
//     extraReducers: (builder) => {
//         builder.addCase(EnergyAuditTableExportDataAPI.pending, (state, action) => {
//             state.isExportLoading = true;
//         });
//         builder.addCase(EnergyAuditTableExportDataAPI.fulfilled, (state, action) => {
//             state.isExportLoading = false;
//             state.ExportTableData = action.payload;
//         });
//         builder.addCase(EnergyAuditTableExportDataAPI.rejected, (state, action) => {
//             console.log("Error", action.payload);
//             state.isExportLoading = false;
//             state.isError = true;
//             state.ExportTableData = null;
//             toastErrorr('Something went wrong')
//         });
//     },
// })

// export const EnergyAuditTableExportDataReducer = EnergyAuditTableExportDataSlice.reducer


// -----------------Delete API ---------------

export const SeweragePreventiveHouseKeepingDeleteAPI = createAsyncThunk("SeweragePreventiveHouseKeepingDelete", async ({ data }) => {
    const {
        T_SW_HouseKeepingID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_SW_HouseKeepingID", T_SW_HouseKeepingID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_SW_T_SW_HouseKeeping_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const SeweragePreventiveHouseKeepingDeleteSlice = createSlice({
    name: "SeweragePreventiveHouseKeepingDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(SeweragePreventiveHouseKeepingDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(SeweragePreventiveHouseKeepingDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(SeweragePreventiveHouseKeepingDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const SeweragePreventiveHouseKeepingDeleteReducer = SeweragePreventiveHouseKeepingDeleteSlice.reducer
